<template>
	<footer class="footer" v-if="visible">
		<router-link class="footer-link footer-link--emergency" :to="{ name : 'Notfall'}"><i class="icon-notfall"></i><br />Notfall</router-link>
		<span class="footer-link" @click="logout" v-if="isAuthenticated"><i class="icon-logout"></i><br />Logout</span>
	</footer>
</template>

<script>
	import {AUTH_LOGOUT} from "@/utils/store/actions/auth";
	import {mapGetters} from 'vuex';
	export default {
        name: "Footer",
	    computed : {
            visible : function () {
	            return ! (['AktuellesSingle','Loading'].indexOf( this.$route.name ) > -1 );
            },
		    ...mapGetters(['isAuthenticated', 'authStatus']),
	    },
	    methods : {
        	logout : function( ) {
        		Events.$emit('logout', true);
		        setTimeout( function() {
			        this.$store.dispatch(AUTH_LOGOUT).then(()=>{ this.$router.push( {name: 'Login'} ); });
		        }.bind(this), 300);
	        }
	    }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/layouts/Footer.vue